import { Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { StormDataStatus, StormInfo } from '../../../../../shared/models/storm.model';
import { InsightsRoute } from '../../../insights-routing.module';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { InfiniteScroll } from '../../../../../shared/tools/InfiniteScrollTools';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { FormattingModule } from '../../../../../shared/formatting/formatting.module';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-storm-report-table',
  imports: [
    FormattingModule,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatCell,
    MatCellDef,
    RouterLink,
    DatePipe,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    MatSort,
    MatTooltip,
    MatSortHeader,
  ],
  templateUrl: './storm-report-table.component.html',
  styleUrl: './storm-report-table.component.scss',
})
export class StormReportTableComponent {

  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);

  @ViewChild(MatSort) sort: MatSort;
  @Input() dataSource: MatTableDataSource<StormInfo>;
  @Output() sortChangedEvent: EventEmitter<void> = new EventEmitter();

  @Output() scrolledToBottomEvent: EventEmitter<void> = new EventEmitter();

  displayedColumns: string[] = ['id', 'name', 'startTime', 'endTime', 'duration', 'locationStatus', 'trackStatus'];

  protected readonly InsightsRoute = InsightsRoute;
  protected readonly StormDataStatus = StormDataStatus;

  getSort(): string | undefined {
    if (!this.sort.active) {
      return undefined;
    }
    return `${this.sort.active},${this.sort.direction}`;
  }

  onScroll(e) {
    InfiniteScroll.onScroll(e, () => this.scrolledToBottomEvent.emit());
  }

  getLocationDataTooltip(storm: StormInfo) {
    if (storm.statusLocation === StormDataStatus.FAILED) {
      return storm.locationErrorMessage;
    } else {
      return null;
    }
  }

  getTrackDataTooltip(storm: StormInfo) {
    if (storm.statusTrack === StormDataStatus.FAILED) {
      return storm.trackErrorMessage;
    } else {
      return null;
    }
  }

  openStormDetail(storm: StormInfo) {
    if (storm.statusTrack !== StormDataStatus.COMPLETED || storm.statusLocation !== StormDataStatus.COMPLETED) {
      // do nothing
    } else {
      this.router.navigate(['../', InsightsRoute.STORM_DETAIL, storm.id], { relativeTo: this.activatedRoute }).then();
    }
  }
}
